import { ChevronDown, ChevronRight } from 'lucide-react'

interface ChartCollapseButtonProps {
  collapsed: boolean
  onToggle?: () => void
  label: string
  controlsId?: string
}

export function ChartCollapseButton({ collapsed, onToggle, label, controlsId }: ChartCollapseButtonProps) {
  if (!onToggle) return null
  const Icon = collapsed ? ChevronRight : ChevronDown
  const action = `${collapsed ? 'Expand' : 'Collapse'} ${label}`
  return (
    <button type="button" onClick={onToggle} aria-expanded={!collapsed} aria-controls={controlsId}
      aria-label={action} title={action}
      className="pointer-events-auto flex h-5 w-5 shrink-0 items-center justify-center rounded text-slate-400 hover:bg-slate-800 hover:text-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-300">
      <Icon className="h-3.5 w-3.5" />
    </button>
  )
}
